import { render, staticRenderFns } from "./Perms.vue?vue&type=template&id=9c7856ce&scoped=true&"
import script from "./Perms.vue?vue&type=script&lang=js&"
export * from "./Perms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7856ce",
  null
  
)

export default component.exports